import { render, staticRenderFns } from "./OrticValueSelect.vue?vue&type=template&id=5ce30d28"
import script from "./OrticValueSelect.vue?vue&type=script&lang=js"
export * from "./OrticValueSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports